import CreateEditOfuCampaignContainer from '~/features/campaigns/components/ofuCreateEditContainer'

function OfuCreateCampaignPage() {
  return <CreateEditOfuCampaignContainer />
}

export default OfuCreateCampaignPage
